<div class="row" [style.display]="display" [ngClass]="extraClasses" *ngIf="show">
	<div class="col-md-12" [ngClass]="textAlign">
		<fa-icon [icon]="['fas', 'spinner']" animation="spin" size="lg" [style]="{ color: color }"></fa-icon>
		<span [style.color]="color" class="ml-1" *ngIf="text">{{ text }}</span>
	</div>
</div>
